import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateProject = api(async function updateProject({ id, project }) {
    return mutate(
        gql`
            mutation UpdateProject($id: String!, $project: ProjectInput!) {
                updateProject(id: $id, project: $project)
            }
        `,
        {
            id,
            project,
        },
        { returns: "updateProject" }
    )
})
